import { faro, LogLevel as FaroLogLevel } from '@grafana/faro-web-sdk';
import { LoggerPort, LogBindings, LogLevel } from './LoggerPort';

const LEVEL_MAP: Record<LogLevel, FaroLogLevel> = {
  debug: FaroLogLevel.DEBUG,
  info: FaroLogLevel.INFO,
  warn: FaroLogLevel.WARN,
  error: FaroLogLevel.ERROR,
};

function stringifyBindings(bindings: LogBindings): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(bindings)) {
    if (value === undefined || value === null) {
      continue;
    }
    if (value instanceof Error) {
      out.errName = value.name;
      out.errMessage = value.message;
      if (value.stack !== undefined) {
        out.errStack = value.stack;
      }
      continue;
    }
    out[key] = typeof value === 'string' ? value : JSON.stringify(value);
  }
  return out;
}

export class FaroLogger implements LoggerPort {
  private readonly inherited: LogBindings;

  public constructor(inherited: LogBindings = {}) {
    this.inherited = inherited;
  }

  public debug(bindings: LogBindings, message: string): void {
    this.emit('debug', bindings, message);
  }

  public info(bindings: LogBindings, message: string): void {
    this.emit('info', bindings, message);
  }

  public warn(bindings: LogBindings, message: string): void {
    this.emit('warn', bindings, message);
  }

  public error(bindings: LogBindings, message: string): void {
    const merged = { ...this.inherited, ...bindings };
    const err = bindings.err ?? this.inherited.err;
    if (err instanceof Error) {
      faro.api.pushError(err, { context: stringifyBindings({ ...merged, message }) });
      return;
    }
    this.emit('error', bindings, message);
  }

  public child(bindings: LogBindings): LoggerPort {
    return new FaroLogger({ ...this.inherited, ...bindings });
  }

  private emit(level: LogLevel, bindings: LogBindings, message: string): void {
    const merged = { ...this.inherited, ...bindings };
    faro.api.pushLog([message], {
      level: LEVEL_MAP[level],
      context: stringifyBindings(merged),
    });
  }
}
